import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { LinearProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { translate } from 'services/i18nService';
import ChatStore from 'stores/ChatStore';
import GroupShowStore from 'stores/GroupShowStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import { CHAT_AVATAR_URL } from 'containers/Chat/Api';
import APIStates from 'enum/APIStates';

import styles from './MobileShowTransition.css';


const muiStyles = () => {
  return {
    barColorPrimary: { backgroundColor: '#60AAC6' },
    root: {
      marginTop: '-5px',
      borderRadius: '3px',
    },
  };
};
const MobileShowTransition = (props) => {
  const {
    classes,
    isDesktop,
    isGroupShow,
    isUserInRoster,
    roomDataReady,
    roomName,
    user,
  } = props;

  const {
    profileChatTabValue,
    setProfileChatTabValue,
    togglePrivateMessages,
  } = ChatStore;
  const {
    closeGroupShowTransitioning,
    getPlayTokenForGroupShow,
  } = GroupShowStore;
  const {
    setPrivateShowReady,
    performerDetails,
    psGsLoading,
  } = ProfileStore;
  const { WebRTCSource } = UserStore;

  useEffect(() => {
    if (psGsLoading === APIStates.LOADED) {
      if (isGroupShow) {
        if (roomDataReady && isUserInRoster) {
          closeGroupShowTransitioning(false);
        }
      } else {
        setPrivateShowReady(true);
      }
    } else if (WebRTCSource) {
      setPrivateShowReady(true);
    }
  }, [
    closeGroupShowTransitioning,
    isGroupShow,
    setPrivateShowReady,
    WebRTCSource,
    psGsLoading,
    roomDataReady,
    isUserInRoster,
  ]);

  useEffect(() => {
    const groupShowData = {
      accessHash: user.accessHash,
      username: user.username,
      roomname: roomName || ProfileStore.profileName,
    };
    if (isGroupShow && roomDataReady && isUserInRoster) {
      getPlayTokenForGroupShow(groupShowData);
    }
  }, [
    getPlayTokenForGroupShow,
    isGroupShow,
    isUserInRoster,
    roomDataReady,
    roomName,
    user.accessHash,
    user.username,
  ]);

  useEffect(() => {
    if (profileChatTabValue !== 1 && !isGroupShow) {
      // switch to private chat tab
      setProfileChatTabValue(1);
      togglePrivateMessages(true);
    }
    if (isGroupShow) {
      togglePrivateMessages(false);
    }
  });

  const { username: performerName } = performerDetails || {};

  let descriptionText = undefined;
  if (isGroupShow) {
    descriptionText = translate(
      'v2profile.entering.group.show',
      { 0: performerName }
    );
  } else {
    descriptionText = translate(
      'v2profile.showTransition.description',
      { 0: performerName }
    );
  }

  const wrapperClass = classnames({
    [styles.transitionWrapperDesktop]: isDesktop,
    [styles.transitionWrapper]: !isDesktop,
  });

  const contentWrapper = classnames({ [styles.contentWrap]: isDesktop });

  const descriptionTextClasses = classnames({
    [styles.descText]: !isDesktop,
    [styles.desktopDesc]: isDesktop,
  });

  return (
    <div className={wrapperClass}>
      <div className={contentWrapper}>
        <div className={styles.profileImageWrapper}>
          <img
            alt="performer"
            src={CHAT_AVATAR_URL.replace('{username}', performerName)}
          />
        </div>
        <p className={descriptionTextClasses}>
          {descriptionText}
        </p>
        <div className={styles.progressWrap}>
          <LinearProgress
            classes={{
              barColorPrimary: classes.barColorPrimary,
              root: classes.root,
            }}
          />
        </div>
      </div>
    </div>
  );
};

MobileShowTransition.propTypes = {
  classes: PropTypes.object,
  isDesktop: PropTypes.bool,
  isGroupShow: PropTypes.bool,
  isUserInRoster: PropTypes.bool,
  roomDataReady: PropTypes.bool,
  roomName: PropTypes.string,
  user: PropTypes.object,
};

MobileShowTransition.defaultProps = {
  classes: {},
  isDesktop: false,
  isGroupShow: false,
  isUserInRoster: false,
  roomDataReady: false,
  roomName: undefined,
  user: undefined,
};

export default withStyles(muiStyles)(observer(MobileShowTransition));
